import classNames from 'clsx'
import { type FunctionComponent } from 'react'

import { TENANT_IT } from 'shared/consts'
import AnimatedPill from 'views/assets/images/animated/animate-pill.svg'
import AnimationRebranding from 'views/assets/images/animated/redcare-animation.gif'
import Image from 'views/components/atoms/Image'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

export const LoadingWrapper: FunctionComponent<{ mobile?: boolean | null }> = ({
  mobile,
}) => {
  const { tenant } = usePublicConfig()

  return (
    <div
      className={classNames({
        'o-PreQueryListItem_loadingWrapper o-SearchBox__results': !mobile,
      })}
    >
      <Image
        src={tenant === TENANT_IT ? AnimationRebranding : AnimatedPill}
        alt="Loading"
        width={129}
        height={129}
        className={classNames(
          'blockui--animation blockui--animationTop u-margin-xx-large--top'
        )}
      />
    </div>
  )
}

export default LoadingWrapper
